export default [
  {
    title: "Dashboard",
    icon: "HomeIcon",
    route: "dashboard",
    Permission: "",
  },

  {
    title: "Action Plan Tool",
    icon: "CrosshairIcon",
    route: "action-plan-tool",
    Permission: "action_tool_page_menu",
  },

  {
    title: "Working Group Tool",
    route: "working-group-tool",
    icon: "ApertureIcon",
    Permission: "working_tool_page_menu",
  },

  {
    title: "Risk Management Tool",
    icon: "ShieldIcon",
    route: "risk-management-tool",
    Permission: "risk_tool_page_menu",
  },

  {
    title: "Report",
    icon: "CheckSquareIcon",
    route: "report",
    Permission: "report_page_menu",
  },

  {
    title: "Users",
    icon: "UsersIcon",
    route: "user-list",
    Permission: "users_page_menu",
  },

  {
    title: "Events",
    icon: "CalendarIcon",
    route: "events",
    Permission: "view_events_menu",
  },
    {
    title: "Training Calendar",
    icon: "CalendarIcon",
    route: "training-calendar",
    Permission: "",
  },

  {
    title: "Settings",
    icon: "SettingsIcon",
    route: "settings",
    Permission: "settings_page_menu",
  },

  {
    title: "Sign Out",
    icon: "LogOutIcon",
    route: "signout",
    Permission: "",
  },

  // {
  //   title: "My Profile",
  //   icon: "UserIcon",
  //   route: "user-profile",
  //   Permission: "",
  // },
];
